<div class="col sub-header-border" [ngClass]="cssClass"></div>